import { UserTeamInjectorProvider } from '@agent-ds/shared/services/api/providers/user-team-injector.provider';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { SalesAmountForUser, SalesAmountType, SalesSummaryForUser, SalesSummaryType } from '@agent-ds/shared/interfaces/sale';

/**
 * 業績管理表 - 担当別月間売上
 */
@Component({
  selector: 'ag-gyoseki-management-sales-amount-table',
  templateUrl: './gyoseki-management-sales-amount-table.component.html',
  styleUrls: ['./gyoseki-management-sales-amount-table.component.scss'],
})
export class GyosekiManagementSalesAmountTableComponent implements OnInit, OnDestroy {
  @Input() selectedManagementTeamId: number = null;
  @Input() salesType: 'ca' | 'rapa' = 'ca';
  @Input() salesForUserModel: SalesAmountForUser = null;
  @Input() salesForTeamModel: { ca: SalesAmountType; rapa: SalesAmountType } = null;
  @Input() salesSummaryForUserModel: SalesSummaryForUser = null;
  @Input() salesSummaryForTeamModel: { ca: SalesSummaryType; rapa: SalesSummaryType } = null;

  constructor(
    public readonly userTeamInjector: UserTeamInjectorProvider,
  ) {}

  ngOnInit() {}
  ngOnDestroy() {}

  get salesForSelectedUser() {
    return (this.salesForUserModel && this.salesForUserModel[this.salesType]) || null;
  }

  get salesForSelectedTeam() {
    return (this.salesForTeamModel && this.salesForTeamModel[this.salesType]) || null;
  }

  get salesSummaryForSelectedUser() {
    return (this.salesSummaryForUserModel && this.salesSummaryForUserModel[this.salesType]) || null;
  }

  get salesSummaryForSelectedTeam() {
    return (this.salesSummaryForTeamModel && this.salesSummaryForTeamModel[this.salesType]) || null;
  }

  public formatCurrency(
    value: number | null | undefined,
    truncateUnderThousand: boolean
  ): number | null | undefined {
    if (value === null || value === undefined) {
      return value;
    }

    if (truncateUnderThousand) {
      // 1,000円未満切り捨て
      return Math.floor(value / 1000);
    }

    return value;
  }

}
